import { render, staticRenderFns } from "./ConfirmPrompt.vue?vue&type=template&id=567adf4a&scoped=true"
import script from "./ConfirmPrompt.vue?vue&type=script&lang=js"
export * from "./ConfirmPrompt.vue?vue&type=script&lang=js"
import style0 from "./ConfirmPrompt.vue?vue&type=style&index=0&id=567adf4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567adf4a",
  null
  
)

export default component.exports